import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Error from '../../views/Error/Error.js'
import { Modal, Content, StyledButton } from './styles'

const ErrorModal = ({ active, toggle }) => {
  useEffect(() => {
    if (active) {
      document.body.classList.add('has-modal')
    } else {
      document.body.classList.remove('has-modal')
    }
  }, [active])

  if (!active) {
    return null
  }
  return (
    <Modal>
      <Content>
        <Error />
        <StyledButton onClick={toggle} label="Stäng" />
      </Content>
    </Modal>
  )
}

ErrorModal.propTypes = {
  active: PropTypes.bool,
  toggle: PropTypes.func
}

ErrorModal.defaultProps = {
  active: false,
  toggle: () => {}
}

export default ErrorModal